import React, { useEffect, useRef, forwardRef, memo } from 'react';
import { Pressable } from 'react-native';
import { __WEB__ } from '../../../constants/styles';

const TouchableOpacity = forwardRef((props, ref) => {
  const buttonRef = useRef(null);

  useEffect(() => {
    // timer to resolve animation issues if button is included in an animating container.
    // animation times are set to 250, so setting to set focus after this completes
    setTimeout(
      function () {
        if (props.autoFocus && buttonRef.current) {
          buttonRef.current?.focus();
        }
      },
      props.animated ? 350 : 0
    );
  }, [props.autoFocus, props.buttonConfig, props.animated]);

  // Expose the focus method to parent components, if needed
  React.useImperativeHandle(ref, () => ({
    focus: () => {
      buttonRef.current?.focus();
    },
  }));
  function _renderNativeComponent() {
    return (
      <Pressable
        {...props}
        ref={buttonRef}
        tabIndex={0} // Ensures the component is focusable on web
      />
    );
  }
  if (__WEB__) {
    const className = `${props.autoFocus ? 'op-focusonload' : ''} ${props.classNames || ''}`;
    return (
      <div className={className} style={props.containerStyle}>
        {_renderNativeComponent()}
      </div>
    );
  } else {
    return _renderNativeComponent();
  }
});

export default memo(TouchableOpacity);
